export const HOMEPAGE = "Polity";
export const ABOUT = " | Polity";
export const SUBJECT = "Our Subjects | Polity";
export const SUBJECT_DETAIL = "Subjects | Polity";
export const SERIES = "Series | Polity";
export const SERIES_DETAIL = "Series Landing | Polity";
export const CONTACT = "Contact | Polity";
export const AUTHOR = "Authors | Polity";
export const BLOG = "Blog | Polity";
export const AUTHOR_BIO = "Authorbio | Polity";
export const AUTHOR_BOOKS = "Author Books | Polity";
export const EVENTS = "Events | Polity";
export const VIEW_EVENT = "View Event | Polity";
export const AUTHOR_BLOG = "Authorblog | Polity";
